import { OffersLoaded, OfferAdded, OfferUpdated, OfferStatusUpdated, OffersAdded } from "./offers.actions";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import OfferCollection from "./offerCollection";
import { AllOfferStatuses, OfferStatus } from "domain/offerStatus";
import Offer from "domain/offer";
import { ProducerUpdated } from "features/settings/producers/producers.action";

export default class OffersReducer extends ReducerBase<OfferCollection> {

    constructor() {
        super();
        this.addHandler(OffersLoaded.EventName, this.handleOffersLoaded);
        this.addHandler(OfferAdded.EventName, this.handleOfferAdded);
        this.addHandler(OffersAdded.EventName, this.handleOffersAdded);
        this.addHandler(OfferUpdated.EventName, this.handleOfferUpdated);
        this.addHandler(OfferStatusUpdated.EventName, this.handleOfferStatusUpdated);
        this.addHandler(ProducerUpdated.EventName, this.handleProducerUpdated);
    }

    handleOffersLoaded(state: OfferCollection = initialState.offers, event: OffersLoaded): OfferCollection {
        const offers = { ...state };
        offers[event.status as number] = event.offers;
        return offers;
    }

    handleOfferAdded(state: OfferCollection, event: OfferAdded): OfferCollection {
        const offers = { ...state };
        addOrUpdate(offers, event.offer.status, event.offer);
        return offers;
    }

    handleOffersAdded(state: OfferCollection, event: OffersAdded): OfferCollection {
        const offers = { ...state };
        event.offers.forEach(o => addOrUpdate(offers, o.status, o));
        return offers;
    }

    handleOfferUpdated(state: OfferCollection, event: OfferUpdated): OfferCollection { 
        const offers = { ...state };

        if (event.initialStatus !== event.offer.status) {
            remove(offers, event.initialStatus, event.offer);
        }
        addOrUpdate(offers, event.offer.status, event.offer);

        return offers;
    }

    handleOfferStatusUpdated(state: OfferCollection, event: OfferStatusUpdated): OfferCollection {
        const offers = { ...state };

        if (event.oldStatus !== event.offer.status) {
            remove(offers, event.oldStatus, event.offer);
        }
        addOrUpdate(offers, event.offer.status, event.offer);

        return offers;
    }
    handleProducerUpdated(state: OfferCollection, event: ProducerUpdated): OfferCollection {
        const offers = { ...state };
        rebuildAllOfferLists(offers, list => list.map(m => m.producer.id === event.producer.id
            ? { ...m, producer: {...m.producer, ...event.producer} }
            : m
        ))
        return offers;
    }

    handleDefault(state: OfferCollection = initialState.offers): OfferCollection {
        return state;
    }
}

function remove(collection: OfferCollection, status: OfferStatus, offer: Offer) {
    rebuildOfferList(collection, status, offers => offers.filter(o => o.id !== offer.id));
}

function addOrUpdate(collection: OfferCollection, status: OfferStatus, offer: Offer) {
    rebuildOfferList(collection, status, offers => {
        let exists = false;
        const newOffers = offers.map(m => {
            if (m.id === offer.id) {
                exists = true;
                return offer;
            }
            return m;
        });

        if (!exists) newOffers.push(offer);

        return newOffers;
    })
}

function rebuildAllOfferLists(collection: OfferCollection, handler: ((offers: Offer[]) => Offer[])) {
    AllOfferStatuses.forEach(status => rebuildOfferList(collection, status, handler));
}

function rebuildOfferList(collection: OfferCollection, status: OfferStatus, handler: ((offers: Offer[]) => Offer[])) {
    const index = status as number;
    let offers = collection[index];

    if (offers === undefined) {
        return;
    }

    const newData = handler(offers.data);
    collection[index] = {
        data: newData,
        totalCount: newData.length
    }
}
